let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dMn8Q")).then(() => parcelRequire('7naaD'));